// @ts-nocheck
(function ($) {
    $(window).on('load resize', function () {
        if ($('.cta').length > 0) {
            $('.card-media').removeClass('no-cta').addClass('overlap');
        }
        else{
            $('.card-media').removeClass('overlap').addClass('no-cta');
        }
    });
})(jQuery);